import BankInfo from "./bankInfo";

const BankInformation = () => {
    return (
        <>
            <div className="cus-bank-info form-card">
                <ul className="nav nav-tabs mb-4" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="private-tab" data-bs-toggle="tab" data-bs-target="#private" type="button" role="tab">Private Person</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="company-tab" data-bs-toggle="tab" data-bs-target="#company" type="button" role="tab">Company</button>
                    </li>
                </ul>

                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="private" role="tabpanel">
                        <BankInfo />
                    </div>

                    <div className="tab-pane fade" id="company" role="tabpanel">
                        <BankInfo />
                    </div>
                </div >
            </div >
        </>
    );
};

export default BankInformation;
